import ChevronDown from "@/assets/ChevronDown.svg";
import PropTypes from "prop-types";
import { Dropdown, Nav, Button } from "react-bootstrap";
import { getHeaderMenu } from "@/functions/getHeaderMenu";
import { useState } from "react";
import classes from "../../styles.module.scss";
import Upload from "@/assets/Upload.svg";
import ArrowRight2 from "@/assets/ArrowRight2.svg";
import Link from "next/link";
import clsx from "classnames";

export default function SiteHeaderNav({ className }) {
  const nav = getHeaderMenu();
  const [show, setShow] = useState(null);

  return (
    <>
      <Nav className={className}>
        {nav.map(({ title, children, url, target }, k) =>
          children && children.length ? (
            <Dropdown
              key={k}
              align={nav.length - 1 === k ? "end" : "start"}
              onMouseEnter={() => setShow(k)}
              onMouseLeave={() => setShow(null)}
            >
              <Nav.Item>
                {
                  url != "/disciplines" ? 
                  <Nav.Link href={url} target={target}>{title}</Nav.Link> : <Nav.Link>{title}</Nav.Link>
                }
                <Dropdown.Toggle variant={false}>
                  <ChevronDown onClick={() => setShow(k)} />
                </Dropdown.Toggle>
              </Nav.Item>
              <Dropdown.Menu show={show === k}>
                {children.map(({ title, url, target }, k) => (
                  <Dropdown.Item as={Nav.Item} key={k} className={classes.dropdown_item}>
                    <Nav.Link href={url} target={target} >{title}</Nav.Link>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <Nav.Item key={k} className={classes.navItem}>
              <Nav.Link href={url} target={target} className={classes.navLink}>
                {title}
              </Nav.Link>
            </Nav.Item>
          ),
        )}
      </Nav>
      <div className={classes.navButtonList}>
        {/* <Link href="/send-us-your-cv">
          <Button className={clsx(classes.navButton, classes.lightHover)}>
            <Upload width={14} height={14} className={classes.navButtonIcon} />
            <span className="font-regular">Share Your CV</span>
          </Button>
        </Link> */}
        <Link href="/submit-a-brief">
          <Button variant="quaternary" className={clsx(classes.navButton, classes.lightHover, classes.darkText)}>
            <Upload width={14} height={14} className={classes.navButtonIcon} />
            <span className="font-regular">Recruit Now</span>
          </Button>
        </Link>
        <Link href="https://timesheets-esguk.techstreamgroup.com/localAccess/index">
          <Button variant="tertiary" className={clsx(classes.navButton, classes.darkHover)}>
          <span className="font-regular">Contractor Zone</span>
            <ArrowRight2 width={14} height={14} className={classes.navButtonIcon} />
          </Button>
        </Link>
      </div>
    </>
  );
}

SiteHeaderNav.defaultProps = {
  className: "",
};

SiteHeaderNav.propTypes = {
  className: PropTypes.string,
};
